// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-07T15:16:39+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190344
//    Project:        617
//    Environment:    7626 - master
//    MD5:            6cee10ce22bf873d19c678ce122a11e8
//    Signature:      eyJpdiI6IitJTzlRRWJnWXhXKys0bURkTUY0TXc9PSIsInZhbHVlIjoiNzhHTkRRdFJpUmdlVTFmXC9KMXc0NmljY3BGMGpHbko0K3BLUnNKSjQ1ZXV3OW5kd1E3R21DUXBvSDhzenhoNjg0T1oxNEZPdjlKcWdjRGRLSm9iSmV1d1NQQnNEVUVaYk9rWHJocWpvQTdPM2ZjaGtTWkxQdEtKYjVkd3RIa0Z1VkFJSEYwYzFTU3ZTRHdISGZEclwvaDV5RFpoMnlHVlFNRTBaaVBDQ2JYSVZaOHNROTN6WWgxQU9zWlpJTUFvQkZ0R01kU2M1UmdNSzZLUm5HVDBwbmtWdVk2bDk0ajRQcHVoQWxpNlpvMkhYK2ozT21lT3ZTcDhZY0dEMkxBM1FjK0RBMGMwRmNsR2FYakozQ1huYlhsYTV0NFBITGR1RWVLbm1aQXpuSUFjTzdRaTFcL0hHYUZNc1htWU1cL25rdjlRM1BUNlE2dkgrWnVDMDRyd2JTT0tnTnVCRE94VFhtb3VYaStpeUdwQTNYenFNRG1jNGI3VFhHaktwVkZ3OFREQXB3OTVQVVRGSFBuVlF4S0tGUTR4bEE9PSIsIm1hYyI6IjA0NjFlNGUzMGUyNjlhMjEyNjc3MWNmM2ZmOWMyY2JlMDc1MjE3N2VlZDg0MjI3M2U2ZGU2NWY4MzE4Y2FjM2QifQ==
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
